import NavButton from '@atoms/NavButton/NavButton';
import HorizontalDirectionEnum from '@models/enums/HorizontalDirectionEnum';
import Carousel from '@molecules/Carousel/Carousel';
import useIsTouchDevice from '@utils/hooks/useIsTouchDevice';
import classNames from 'classnames';
import { PropsWithChildren, useEffect, useState } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper } from 'swiper/types';

interface Props {
  readonly id: string;
  readonly hasMultipleItems: boolean;
  readonly enabledNavigationArrowColor?: string;
}

const NotificationCarousel = ({
  id,
  hasMultipleItems,
  enabledNavigationArrowColor,
  children,
}: PropsWithChildren<Props>) => {
  const [swiperInstance, setSwiperInstance] = useState<Swiper>();
  const isTouchDevice = useIsTouchDevice();

  useEffect(() => {
    if (!swiperInstance || isTouchDevice === undefined) return;
    swiperInstance.allowTouchMove = isTouchDevice;
  }, [isTouchDevice, swiperInstance]);

  return (
    <div className="flex min-h-[2.5rem] w-full">
      <div
        className={classNames('ml-7.5 self-center', {
          hidden: !hasMultipleItems || isTouchDevice,
        })}
      >
        <NavButton
          direction={HorizontalDirectionEnum.Left}
          id={id}
          hasBackgroundColor={false}
          sizeClassName="h-6 w-6"
          enabledArrowColor={enabledNavigationArrowColor}
        />
      </div>

      <Carousel
        loop
        className="w-full min-w-0"
        navId={id}
        id={id}
        additionalModules={[Autoplay]}
        autoplay={{
          delay: 5000,
        }}
        onSwiper={setSwiperInstance}
      >
        {children}
      </Carousel>

      <div
        className={classNames('mr-7.5 self-center', {
          hidden: !hasMultipleItems || isTouchDevice,
        })}
      >
        <NavButton
          direction={HorizontalDirectionEnum.Right}
          id={id}
          hasBackgroundColor={false}
          sizeClassName="h-6 w-6"
          enabledArrowColor={enabledNavigationArrowColor}
        />
      </div>
    </div>
  );
};

export default NotificationCarousel;
